import { createRoot } from 'react-dom/client';
import App from './App';
import { API_CONFIG } from './config/api';
import { cleanTokenFromUrl } from './lib/api/tokenUtils';
import './styles/globals.css';

// The Go SPA handler sets the httpOnly cookie and redirects to strip ?token=.
// This is a safety net to clean the URL if the redirect didn't happen.
cleanTokenFromUrl();

// One-shot wire-up log so deploys can verify AGENT_API_BASE_URL reached the
// SPA via window.__APP_CONFIG__ injection. Empty value is flagged loudly.
if (API_CONFIG.controlPlaneUrl) {
  console.info(`[boot] controlPlaneUrl = ${API_CONFIG.controlPlaneUrl}`);
} else {
  console.warn(
    '[boot] controlPlaneUrl is empty — auth redirects will be disabled. ' +
      'Check AGENT_API_BASE_URL on compute-api (injected via window.__APP_CONFIG__).'
  );
}

createRoot(document.getElementById('root')!).render(<App />);
